import configAxios from 'axios';
import router from "../router";
import store from "../store";

const apiInstance = configAxios.create({
    baseURL: process.env.VUE_APP_API_URL,
    headers: {

    }
});
apiInstance.interceptors.request.use((config) => {
    config.data = JSON.stringify({...config.data, token: process.env.VUE_APP_GLOBAL_TOKEN});
    return config;
});

// apiInstance.interceptors.response.use(
//     (response) => response,
//     (error) => {
//         const {response} = error;
//         if (response?.status === 401 || response?.status === 403) {
//             localStorage.removeItem('token');
//             localStorage.removeItem('access_token');
//             localStorage.removeItem('user_id');
//             router.push('/login');
//         }
//     },
// );

export default apiInstance;
